import { ComponentType, FC } from "react";

import ErrorBoundary from "#components/ErrorBoundary/ErrorBoundary";
/**
 * This is the nuclear-proof version that works with:
 *   • connect() from react-redux
 *   • helmetified pages
 *   • class components
 *   • any HOC
 *   • strict TypeScript
 */

export function createRouteComponent<P extends Record<string, unknown>>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>,
  staticProps?: P
): FC<Record<string, unknown>> {
  const RouteWrapper: FC<Record<string, unknown>> = (runtimeProps) => (
    <ErrorBoundary>
      <Component {...(staticProps ?? {})} {...runtimeProps} />
    </ErrorBoundary>
  );

  const displayName = Component.displayName || Component.name || "Component";
  RouteWrapper.displayName = `Route(${displayName})`;

  return RouteWrapper;
}
